import {Injectable} from '@angular/core';

import {
  FourDService,
  Account,
  Folder,
  Dataset,
  JobBatch,
  Transform,
  TransformGroup,
  ChunkedFileUploader,
  Job,
  Project,
  TransformType,
  Annotation
} from '4d-mapper';
import { Subject, Subscription, concat, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FolderEvent, FileEvent, FileDataService } from './file-data.service';
import { SceneEvent, AnnotationEvent, SyncAgentEvent } from './map-event.objects';
import { filter } from 'rxjs/operators';
import { XsIdentityInterface } from '@src/app/xs/interfaces/identify.interface';

@Injectable()
export class StreamDataService implements XsIdentityInterface {

  __ID = XsIdentityInterface.__init(this);

  
  private _subs:Subscription[] = []
  private _blacklist:string[] = []

  private _folderEventsSubj = new Subject<FolderEvent>()
  private _fileEventsSubj = new Subject<FileEvent>()
  private _sceneEventSubj = new Subject<SceneEvent>()
  private _annotsEventSubj = new Subject<AnnotationEvent>()
  private _syncEventSubj = new Subject<SyncAgentEvent>()

  private _folderEvents = this._folderEventsSubj.asObservable()
  private _fileEvents = this._fileEventsSubj.asObservable()
  private _sceneEvents = this._sceneEventSubj.asObservable()
  private _annotationEvents = this._annotsEventSubj.asObservable()

  __events:string[] = ['folder','file','scene','annotation'];

  constructor(private fileManager: FileDataService,private fourD: FourDService) {

      this.initSockEvents()
      this.initProcessingListeners()
      this.initOtherFileEvents()

      const c = 'background-color:#ddd;color:#521';
      const d = 'font-size:15px;background-color:#cb4;color:#fff';

      /* if(!environment.production){
        this.fourD.onSocketCommand('*!').subscribe(s => console.log('%c v2/stream-data %c socket ',c,d,s))
        this.fileEvents.subscribe(s => console.log('%c v2/stream-data %c fileEvent ',c,d,s.item.name,s.event))
        this.folderEvents.subscribe(s => console.log('%c v2/stream-data %c folderEvent ',c,d,s.item.name,s.event))
      } */
  }
  



  private initSockEvents(){

    this.fourD.onSocketCommand('dropbox_start').subscribe(tc => {
      this.fileManager.processingItems.add({
        task:{
          id:tc.link,
          agent:'dropbox',
          name:tc.name,
          targetFolder:tc.targetFolder,
          size:tc.bytes,
          isDir:tc.isDir
        },progress:0,status:'Fetching'
      })
    
    })
    this.fourD.onSocketCommand('dropbox_stop').subscribe(tc => {
      this.fileManager.processingItems.values = this.fileManager.processingItems.values.filter(a => a.task.id != tc.link)
    })
    this.fourD.onSocketCommand('scene_photo_removeall').subscribe(tc => {
      var tg = this.fourD.V.findCached(TransformGroup,tc.scene.id)
      if(tg){
        this._sceneEventSubj.next(
          new SceneEvent(tg,'photo_removed_all',)
        )
      }
    })
    this.fourD.onSocketCommand('scene_transform_removed').subscribe(tc => {
      var tg = this.fourD.V.findCached(TransformGroup,tc.scene.id)
      if(tg){
        this._sceneEventSubj.next(
          new SceneEvent(tg,'transform_removed',{
            id:tc.transform.id,
            obj:this.fourD.V.findCached(Transform,tc.transform.id)
          })
        )
      }
    })
    this.fourD.onSocketCommand('scene_transform_added').subscribe(tc => {
      var tg = this.fourD.V.findCached(TransformGroup,tc.scene.id)
      var t = this.fourD.V.findCached(Transform,tc.transform.id) 
      if(tg){
        if(!t){
          t = new Transform(this.fourD.V).set(tc.transform)
        
          t.fetchObservable().subscribe(r => {
            this.fourD.V.registerCacheClass(Transform,[r])
            this._sceneEventSubj.next(new SceneEvent(tg,'transform_added',{
            obj:t,
            id:tc.transform.id
            })
            )
          })
        }
        else{
          t.set(tc.transform)
        
          this._sceneEventSubj.next(new SceneEvent(tg,'transform_added',t))
        
        }
      }
    })
    this.fourD.onSocketCommand('scene_photo_added').subscribe(tc => {
      var tg = this.fourD.V.findCached(TransformGroup,tc.scene.id)
      var t = this.fourD.V.findCached(Transform,tc.photo.id) 
      if(tg){
        if(tc.photos)
          tg._photo_count = tc.photos
        if(!t){
          this.fourD.V.searchByObject(Transform).equals('id',tc.photo.id).useCache(true).limit(780).queryObservable().subscribe(r => {
            this._sceneEventSubj.next(new SceneEvent(tg,'photo_added',{
            obj:r.items[0],
            id:tc.photo.id
            })
            )
          })
        }
        else{
          t.set(tc.photo)
        
          this._sceneEventSubj.next(new SceneEvent(tg,'photo_added',t))
        
        }
      }

    })

    this.fourD.onSocketCommand('create_annotation').subscribe(tc => {

      var ds = this.fourD.V.findCached(Annotation,tc.id)
      if(!ds){
        ds = new Annotation(this.fourD.V).set(tc)
        this.fourD.V.registerCacheClass(Annotation,[ds])
        this._annotsEventSubj.next(new AnnotationEvent(ds,'ADD'))
      }
    })

    this.fourD.onSocketCommand('update_annotation').subscribe(tc => {

      var ds = this.fourD.V.findCached(Annotation,tc.id)
      if(ds){
        ds.set(tc)
        this._annotsEventSubj.next(new AnnotationEvent(ds,'UPDATE'))
      }
    })


    this.fourD.onSocketCommand('delete_annotation').subscribe(tc => {

      var ds = this.fourD.V.findCached(Annotation,tc.id)
      if(ds)
        this._annotsEventSubj.next(new AnnotationEvent(ds,'REMOVE'))
      
    })


    this.fourD.onSocketCommand('create_transform_group').subscribe(tc => {

      var ds = this.fourD.V.findCached(TransformGroup,tc.id)
      if(!ds){
        ds = new TransformGroup(this.fourD.V).set(tc)
        this.fourD.V.registerCacheClass(TransformGroup,[ds])
        this._sceneEventSubj.next(new SceneEvent(ds,'fetched'))
      }
    })

    this.fourD.onSocketCommand('update_transform_group').subscribe(tc => {

      var ds = this.fourD.V.findCached(TransformGroup,tc.id)
      if(ds){
        ds.set(tc)
        this._sceneEventSubj.next(new SceneEvent(ds,'changed'))
      }
    })


    this.fourD.onSocketCommand('delete_transform_group').subscribe(tc => {

      var ds = this.fourD.V.findCached(TransformGroup,tc.id)
      if(ds)
        this._sceneEventSubj.next(new SceneEvent(ds,'unfetched'))
      
    })

    this.fourD.onSocketCommand('create_folder').subscribe(tc => {

      var ds = this.fourD.V.findCached(Folder,tc.id)
      if(!ds){
        ds = new Folder(this.fourD.V).set(tc)
        this.fourD.V.registerCacheClass(Folder,[ds])
        this._folderEventsSubj.next(new FolderEvent(ds,'ADD'))
      }
    })

    this.fourD.onSocketCommand('update_folder').subscribe(tc => {

      var ds = this.fourD.V.findCached(Folder,tc.id)
      if(ds){
        ds.set(tc)
        this._folderEventsSubj.next(new FolderEvent(ds,'UPDATE'))
      }
    })

    this.fourD.onSocketCommand('delete_folder').subscribe(tc => {

      var ds = this.fourD.V.findCached(Folder,tc.id)
      if(ds)
        this._folderEventsSubj.next(new FolderEvent(ds,'REMOVE'))
      
    })

    this.fourD.onSocketCommand('create_dataset').subscribe(tc => {

      var ds = this.fourD.V.findCached(Dataset,tc.id)
      if(!ds){
        ds = new Dataset(this.fourD.V).set(tc)
        if ( this.fourD.activeUser ) {
          ds['__from_user'] = this.fourD.activeUser.id;
        }
        this.fourD.V.registerCacheClass(Dataset,[ds])
        this._fileEventsSubj.next(new FileEvent(ds,'ADD',{mode:'new',socket:'create_dataset',ref:tc}))
      }
    })

    this.fourD.onSocketCommand('update_dataset').subscribe(tc => {

      var ds = this.fourD.V.findCached(Dataset,tc.id)
      var dsJob = this.fileManager.processingItems.values.find(a => a.task.id == tc.id)
    
      if(ds){
        ds.set(tc)
        this._fileEventsSubj.next(new FileEvent(ds,'UPDATE',{socket:'update_dataset',mode:'cached',ref:tc}))
      }
      else{
        var newDS = new Dataset(this.fourD.V).set(tc)
        this.fourD.V.registerCacheClass(Dataset,[newDS])
        newDS.fetchObservable().subscribe(s => 
          this._fileEventsSubj.next(new FileEvent(newDS,'ADD',{socket:'update_dataset',mode:'new',ref:tc}))
        )
      }

      if(dsJob){
        this.fileManager.processingItems.emmit(dsJob,'UPDATE')
        this.fileManager.processingItems.remove(dsJob)
      }
    })

    this.fourD.onSocketCommand('delete_dataset').subscribe(tc => {

      var ds = this.fourD.V.findCached(Dataset,tc.id)
      var dsJob = this.fileManager.processingItems.values.find(a => a.task.id == tc.id)
      var dsUl = this.fileManager.uploadingFiles.values.find(a => a.dataset.id == tc.id)
    
      if(ds){
        this._fileEventsSubj.next(new FileEvent(ds,'deleted',{mode:'delete',socket:'delete_dataset',ref:tc}))
        this._fileEventsSubj.next(new FileEvent(ds,'REMOVE',{socket:'delete_dataset',ref:tc}))
      }
      if(dsJob){
        this.fileManager.processingItems.remove(dsJob)
      }
      if(dsUl){
        this.fileManager.uploadingFiles.remove(dsUl)
      }
    })
  }

  __addIn(these:string[] = [],from:any) {
    these.forEach( me => {
      
    });
  }

  private initProcessingListeners(){

    this.fourD.onSocketCommand('task_update').subscribe(s => {
  // dont keep polling if it made the blacklist
      if(s.dataset && s.dataset.id && this._blacklist.indexOf('t' + s.dataset.id) != -1)
        return
      if(s.dataset && s.dataset.id){
        var current = this.fourD.V.findCached(Dataset,s.dataset && s.dataset.id)
        
        var load = (j:Dataset) => {
          var v = this.fileManager.processingItems.values.find(f => f.task == j)
          if(!v){
            v = {
              task:j,
              progress:1,
              status:''
            }
          }
          v.progress = s.progress
          v.status = s.status
          
          this.fileManager.processingItems.set(v)

          if(v.task instanceof Dataset){
            this._fileEventsSubj.next(new FileEvent(v.task,'UPDATE',{mode:'processing',socket:'task_update',ref:v}))
          }

          if(v.status == 'finished'){
            this.fileManager.processingItems.emmit(v,'processing_finished')
            this.fileManager.processingItems.remove(v)
          }
          else if(v.status == 'error'){
            this.fileManager.processingItems.emmit(v,'processing_error')
            this.fileManager.processingItems.remove(v)
          }
        }
        if(!current){
          this.fourD.V.searchByObject(Dataset).equals('id',s.dataset.id).useCache(true).limit(781).queryObservable().subscribe(res => {
            if(res.items.length != 1)
              this._blacklist.push('t' + s.job_id)
            else
              load(res.items[0])
          })
        }
        else 
          load(current)
      }
    })
    this.fourD.onSocketCommand('job_batch_update').subscribe(s => {

      // dont keep polling if it made the blacklist
      if(s.job_id && this._blacklist.indexOf('j' + s.job_id) != -1)
        return
      if(s.job_id){
        var current = this.fourD.V.findCached(Job,s.job_id)
        
        var load = (j:Job) => {
          var v = this.fileManager.processingItems.values.find(f => f.task == j)
          if(!v){
            v = {
              task:j,
              progress:1,
              status:''
            }
          }
          v.progress = s.progress
          v.status = s.status
          
          this.fileManager.processingItems.set(v)

          if(v.status == 'finished'){
            this.fileManager.processingItems.emmit(v,'processing_finished')
            this.fileManager.processingItems.remove(v)
          }
          else if(v.status == 'error'){
            this.fileManager.processingItems.emmit(v,'processing_error')
            this.fileManager.processingItems.remove(v)
          }
        }
        if(!current){
          this.fourD.V.searchByObject(Job).equals('id',s.job_id).useCache(true).limit(782).queryObservable().subscribe(res => {
            if(res.items.length != 1)
              this._blacklist.push('j' + s.job_id)
            else
              load(res.items[0])
          })
        }
        else 
          load(current)

      }
    })
  }

  private initOtherFileEvents(){

    this._subs.push(this.fileManager.processingItems.events.pipe(filter(s => 
      s.item.task instanceof Dataset
    )).subscribe(s => {
      if(s.event == 'ADD')
        this._fileEventsSubj.next(new FileEvent(<Dataset>s.item.task,'processing',{ref:s}))
      else if(s.event == 'REMOVE')
        this._fileEventsSubj.next(new FileEvent(<Dataset>s.item.task,'processing_finished',{ref:s}))
      else if(s.event == 'UPDATE')
        this._fileEventsSubj.next(new FileEvent(<Dataset>s.item.task,'UPDATE',{mode:'process',ref:s}))
    }))

    this._subs.push(this.fileManager.uploadingFiles.events.subscribe(s => {
      if(s.event == 'ADD')
        this._fileEventsSubj.next(new FileEvent(s.item.dataset,'uploading',{ref:s}))
      else if(s.event == 'REMOVE')
        this._fileEventsSubj.next(new FileEvent(s.item.dataset,'upload_finished',{ref:s}))
      else if(s.event == 'UPDATE')
        this._fileEventsSubj.next(new FileEvent(s.item.dataset,'UPDATE',{mode:'upload',ref:s}))
      
    }))
  }

  get fileEvents():Observable<FileEvent>{
    var presub = []
    this.fileManager.uploadingFiles.values.forEach(u => presub.push(new FileEvent(u.dataset,'uploading',{ref:u})))
    this.fileManager.processingItems.values.filter(u => u.task instanceof Dataset).forEach(u => presub.push(new FileEvent(<Dataset>u.task,'uploading',{mode:'processing?',ref:u})))
    
    return concat(presub,this._fileEvents)
  } 
  get folderEvents(){
    return this._folderEvents
  } 
  get sceneEvents(){
    return this._sceneEvents
  } 

  get annotationEvents(){
    return this._annotationEvents
  }

  //get selectedFolder(){
  //  return this._selectedFolder
  //}
  //get selectedFiles(){
  //  return this._selectedFiles
  //}
  
 
}
